export const exercises = [
  // ── § 34 PatG: Anmeldepflichtbestandteile ──────────────────────────────────

  {
    id: "da-patg2-001",
    topic: "§ 34 PatG — Mindesterfordernisse der Anmeldung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "multi",
    level: 1,
    sources: ["patg34"],
    title: "Mindestinhalt für rechtswirksame Patentanmeldung",
    prompt:
      "Welche Angaben muss eine Patentanmeldung gemäß § 34 Abs. 3 Nr. 1, 2 und 4 PatG mindestens enthalten, damit sie rechtswirksam ist?",
    options: [
      { text: "Den Namen des Anmelders", correct: true },
      { text: "Einen Erteilungsantrag mit kurzer und genauer Bezeichnung der Erfindung", correct: true },
      { text: "Eine Beschreibung der Erfindung", correct: true },
      { text: "Patentansprüche", correct: false },
    ],
    explanation:
      "§ 34 Abs. 3 Nr. 1, 2 und 4 PatG nennt als Mindesterfordernisse: (1) den Namen des Anmelders, (2) den Erteilungsantrag mit kurzer und genauer Bezeichnung der Erfindung, und (4) eine Beschreibung. Patentansprüche sind für den Anmeldetag nicht zwingend erforderlich — sie können nachgereicht werden.",
  },

  {
    id: "da-patg2-002",
    topic: "§ 34 PatG — Anmeldeunterlagen",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg34"],
    title: "Einreichungswege beim DPMA",
    prompt:
      "Auf welchem Weg kann eine Patentanmeldung beim DPMA eingereicht werden?",
    options: [
      { text: "Elektronisch über DPMAdirektPro oder per Post", correct: true },
      { text: "Nur elektronisch über DPMAdirektPro", correct: false },
      { text: "Nur per Post oder persönliche Abgabe", correct: false },
      { text: "Elektronisch, per Post oder per Fax", correct: false },
    ],
    explanation:
      "Eine Patentanmeldung kann beim DPMA entweder in elektronischer Form über DPMAdirektPro oder per Post eingereicht werden. Fax ist kein anerkannter Einreichungsweg für Patentanmeldungen.",
  },

  {
    id: "da-patg2-003",
    topic: "§ 34 PatG — Fremdsprachige Anmeldungen",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg34"],
    title: "Übersetzungsfrist bei englischer Anmeldung",
    prompt:
      "Ein Anmelder reicht seine Patentanmeldung in englischer Sprache ein. Innerhalb welcher Frist muss er eine deutsche Übersetzung nachreichen?",
    options: [
      { text: "12 Monate nach dem Anmeldetag", correct: true },
      { text: "3 Monate nach dem Anmeldetag", correct: false },
      { text: "15 Monate nach dem Anmeldetag", correct: false },
      { text: "6 Monate nach dem Anmeldetag", correct: false },
    ],
    explanation:
      "Bei einer Anmeldung in englischer oder französischer Sprache beträgt die Frist für das Nachreichen der deutschen Übersetzung 12 Monate. Bei anderen Fremdsprachen sind es nur 3 Monate. Bei Inanspruchnahme eines früheren Zeitpunkts anstelle des Anmeldetags verlängert sich die Frist auf 15 Monate nach diesem Zeitpunkt.",
  },

  {
    id: "da-patg2-004",
    topic: "§ 34 PatG — Anmeldeunterlagen",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg34"],
    title: "Pflichtbestandteil: Zusammenfassung",
    prompt:
      "Was gilt für die Zusammenfassung einer Patentanmeldung gemäß § 36 PatG?",
    options: [
      { text: "Sie ist Pflichtbestandteil der Anmeldungsunterlagen, aber nicht Mindesterfordernis für den Anmeldetag", correct: true },
      { text: "Sie ist zwingend erforderlich für die Rechtswirksamkeit der Anmeldung", correct: false },
      { text: "Sie muss innerhalb von 3 Monaten nach dem Anmeldetag eingereicht werden", correct: false },
      { text: "Sie ist optional und kann jederzeit nachgereicht werden", correct: false },
    ],
    explanation:
      "Die Zusammenfassung (§ 36 PatG, § 13 PatV) ist zwar Bestandteil der vollständigen Anmeldungsunterlagen, zählt aber nicht zu den Mindesterfordernissen nach § 34 Abs. 3 Nr. 1, 2 und 4 PatG, die für die Rechtswirksamkeit (Anmeldetag) erforderlich sind. Formelle Mängel beim Fehlen der Zusammenfassung werden in der Formalprüfung beanstandet.",
  },

  {
    id: "da-patg2-005",
    topic: "§ 34 Abs. 4 PatG — Ausführbarkeit",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg34"],
    title: "Ausführbarkeitserfordernis",
    prompt:
      "Was verlangt § 34 Abs. 4 PatG in Bezug auf die Offenbarung der Erfindung?",
    options: [
      { text: "Die Erfindung muss so deutlich und vollständig offenbart sein, dass ein Fachmann sie ausführen kann", correct: true },
      { text: "Die Erfindung muss so beschrieben sein, dass ein Laie sie nachvollziehen kann", correct: false },
      { text: "Die Erfindung muss durch mindestens ein Ausführungsbeispiel illustriert sein", correct: false },
      { text: "Die Erfindung muss durch experimentelle Daten belegt sein", correct: false },
    ],
    explanation:
      "§ 34 Abs. 4 PatG verlangt, dass die Erfindung in der Anmeldung so deutlich und vollständig offenbart sein muss, dass ein Fachmann sie ausführen kann. Maßstab ist der zuständige Durchschnittsfachmann, nicht ein Laie. Ausführungsbeispiele sind nicht zwingend, helfen aber die Ausführbarkeit zu belegen.",
  },

  {
    id: "da-patg2-006",
    topic: "§ 34 Abs. 5 PatG — Einheitlichkeit",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg34"],
    title: "Einheitlichkeitsgrundsatz",
    prompt:
      "Was bedeutet das Einheitlichkeitserfordernis nach § 34 Abs. 5 PatG?",
    options: [
      { text: "Eine Patentanmeldung darf nur eine Erfindung oder eine Gruppe von Erfindungen enthalten, die eine einzige allgemeine erfinderische Idee verwirklichen", correct: true },
      { text: "Eine Patentanmeldung darf nur einen einzigen Patentanspruch enthalten", correct: false },
      { text: "Die Anmeldungsunterlagen müssen in einer einheitlichen Sprache verfasst sein", correct: false },
      { text: "Alle Patentansprüche müssen auf denselben Oberbegriff zurückführbar sein", correct: false },
    ],
    explanation:
      "§ 34 Abs. 5 PatG verlangt, dass eine Patentanmeldung nur eine Erfindung oder eine Gruppe von Erfindungen enthalten darf, die eine einzige allgemeine erfinderische Idee verwirklichen. Dieses Einheitlichkeitserfordernis dient der Rechtssicherheit und verhindert die missbräuchliche Verwendung von Gebühren.",
  },

  {
    id: "da-patg2-007",
    topic: "§ 34 PatG — Patentansprüche",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg34"],
    title: "Fakultative Merkmale in Patentansprüchen",
    prompt:
      "Welche Wirkung haben fakultative Merkmale wie 'insbesondere', 'vorzugsweise' oder 'zum Beispiel' in einem Patentanspruch?",
    options: [
      { text: "Sie wirken nicht einschränkend und sind für die Prüfung des Schutzumfangs nicht relevant", correct: true },
      { text: "Sie schränken den Schutzumfang des Patentanspruchs ein", correct: false },
      { text: "Sie erweitern den Schutzumfang über den Wortlaut des Anspruchs hinaus", correct: false },
      { text: "Sie sind zulässig, zählen aber zum Stand der Technik", correct: false },
    ],
    explanation:
      "Fakultative Merkmale wie 'insbesondere', 'vorzugsweise' oder 'zum Beispiel' im Patentanspruch wirken nicht einschränkend und sind für die Prüfung des Schutzumfangs nicht relevant. Der Anspruch wird so ausgelegt, als ob diese Merkmale nicht vorhanden wären — das beanspruchte Schutzbegehren ist damit weiter als es auf den ersten Blick erscheint.",
  },

  {
    id: "da-patg2-008",
    topic: "§ 34 PatG — Anspruchsstruktur",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg34"],
    title: "Inhalt des Hauptanspruchs",
    prompt:
      "Was muss der Hauptanspruch einer Patentanmeldung gemäß § 9 Abs. 4 PatV enthalten?",
    options: [
      { text: "Die wesentlichen Merkmale der Erfindung", correct: true },
      { text: "Alle Merkmale der Erfindung einschließlich bevorzugter Ausführungsformen", correct: false },
      { text: "Den technischen Effekt der Erfindung und eine Ausführungsform", correct: false },
      { text: "Mindestens einen Oberbegriff und ein kennzeichnendes Merkmal", correct: false },
    ],
    explanation:
      "Gemäß § 9 Abs. 4 PatV muss der Hauptanspruch die wesentlichen Merkmale der Erfindung enthalten. Bevorzugte Ausführungsformen und Detailmerkmale können in Unteransprüchen beansprucht werden. Der zweiteilige Anspruch (Oberbegriff + kennzeichnender Teil) ist eine mögliche, aber nicht zwingend vorgeschriebene Form.",
  },

  {
    id: "da-patg2-009",
    topic: "§ 34 PatG — Anspruchsstruktur",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg34"],
    title: "Ein- vs. zweiteilige Anspruchsfassung",
    prompt:
      "Wann ist eine zweiteilige Anspruchsfassung (Oberbegriff + kennzeichnender Teil) typischerweise angebracht?",
    options: [
      { text: "Wenn ein nächstliegender Stand der Technik existiert, von dem sich die Erfindung durch neue Merkmale abgrenzt", correct: true },
      { text: "Immer, wenn mehr als ein Merkmal beansprucht wird", correct: false },
      { text: "Nur bei Vorrichtungsansprüchen, nicht bei Verfahrensansprüchen", correct: false },
      { text: "Wenn die Erfindung aus mehreren unabhängigen Teilaspekten besteht", correct: false },
    ],
    explanation:
      "Die zweiteilige Anspruchsfassung ist angebracht, wenn ein nächstliegender Stand der Technik bekannt ist: Der Oberbegriff enthält die bekannten Merkmale, der kennzeichnende Teil die neuen, erfinderischen Merkmale. Bei fehlendem oder nicht klar abgrenzbarem Stand der Technik ist die einteilige Fassung üblich.",
  },

  {
    id: "da-patg2-010",
    topic: "§ 37 PatG — Erfinderbenennung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg37"],
    title: "Frist für Erfinderbenennung",
    prompt:
      "Innerhalb welcher Frist muss die Erfinderbenennung nach § 37 PatG beim DPMA eingereicht werden?",
    options: [
      { text: "15 Monate nach dem Anmeldetag", correct: true },
      { text: "12 Monate nach dem Anmeldetag", correct: false },
      { text: "3 Monate nach dem Anmeldetag", correct: false },
      { text: "Gleichzeitig mit der Anmeldung", correct: false },
    ],
    explanation:
      "Die Erfinderbenennung nach § 37 PatG muss innerhalb von 15 Monaten nach dem Anmeldetag eingereicht werden. Das Fehlen oder die Unvollständigkeit der Erfinderbenennung innerhalb dieser Frist stellt einen formellen Mangel dar, der im Rahmen der Formalprüfung gemäß § 42 PatG beanstandet wird.",
  },

  {
    id: "da-patg2-011",
    topic: "§ 34 PatG — Beschreibung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg34"],
    title: "Auslegung des Patentanspruchs",
    prompt:
      "Aus welcher Perspektive ist ein Patentanspruch bei der Sachprüfung auszulegen?",
    options: [
      { text: "Aus Sicht des zuständigen Fachmanns unter Heranziehung der Beschreibung und der Zeichnungen", correct: true },
      { text: "Aus Sicht des Erfinders gemäß den ursprünglichen Anmeldungsunterlagen", correct: false },
      { text: "Anhand des Wortlauts des Anspruchs ohne Heranziehung der Beschreibung", correct: false },
      { text: "Aus Sicht eines Laien im betreffenden technischen Gebiet", correct: false },
    ],
    explanation:
      "Der Patentanspruch wird aus der Sicht des jeweils zuständigen Fachmanns ausgelegt, wobei Beschreibung und Zeichnungen heranzuziehen sind. Der Sinngehalt des Patentanspruchs in seiner Gesamtheit und der Beitrag der einzelnen Merkmale sind zu bestimmen (BPatG GRUR 2014, 545 — Batterieüberwachungsgerät).",
  },

  {
    id: "da-patg2-012",
    topic: "§ 34 PatG — Anspruchskategorien",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "multi",
    level: 1,
    sources: ["patg34"],
    title: "Patentkategorien im deutschen Patentrecht",
    prompt:
      "Welche Patentkategorien (Anspruchskategorien) sind im deutschen Patentrecht möglich?",
    options: [
      { text: "Vorrichtungsanspruch (Erzeugnisanspruch)", correct: true },
      { text: "Verfahrensanspruch", correct: true },
      { text: "Verwendungsanspruch", correct: true },
      { text: "Konzeptanspruch", correct: false },
    ],
    explanation:
      "Im deutschen Patentrecht sind folgende Anspruchskategorien möglich: Erzeugnisansprüche (Vorrichtungen, Stoffe, Zusammensetzungen), Verfahrensansprüche (Herstellungs- und Anwendungsverfahren) und Verwendungsansprüche. 'Konzeptanspruch' ist kein anerkannter Begriff im deutschen Patentrecht.",
  },

  {
    id: "da-patg2-013",
    topic: "§ 34 PatG — Anmeldeunterlagen",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg34"],
    title: "Biologisches Material — Herkunftsangaben",
    prompt:
      "Welche besonderen Angaben sind bei Patentanmeldungen zu biologischem Material gemäß § 4 Abs. 7 PatV zu machen?",
    options: [
      { text: "Angaben zum geographischen Herkunftsort des biologischen Materials", correct: true },
      { text: "Angaben zur genetischen Sequenz des biologischen Materials", correct: false },
      { text: "Nachweise über die Einwilligung des Herkunftslandes", correct: false },
      { text: "Angaben zur kommerziellen Verfügbarkeit des biologischen Materials", correct: false },
    ],
    explanation:
      "Nach § 4 Abs. 7 PatV sind Angaben zum geographischen Herkunftsort des biologischen Materials zu machen, sofern dieser bekannt ist. Dies dient dem Schutz biologischer Vielfalt und der Implementierung des Nagoya-Protokolls. Genetische Sequenzen erfordern besondere Sequenzprotokolle nach §§ 11–11b PatV.",
  },

  {
    id: "da-patg2-014",
    topic: "§ 34 PatG — Überblick Anmeldeverfahren",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 3,
    sources: ["patg34"],
    title: "Anmeldetag bei fehlenden Patentansprüchen",
    prompt:
      "Ein Anmelder reicht eine Patentanmeldung ein, die den Namen des Anmelders, einen Erteilungsantrag mit Bezeichnung der Erfindung und eine Beschreibung enthält — aber keine Patentansprüche. Was gilt?",
    options: [
      { text: "Die Anmeldung erhält gleichwohl einen Anmeldetag; Patentansprüche können nachgereicht werden", correct: true },
      { text: "Die Anmeldung wird zurückgewiesen, da Patentansprüche zwingende Mindestvoraussetzung sind", correct: false },
      { text: "Die Anmeldung erhält keinen Anmeldetag bis Patentansprüche eingereicht werden", correct: false },
      { text: "Die Anmeldung erhält einen Anmeldetag, wird aber automatisch als zurückgenommen behandelt", correct: false },
    ],
    explanation:
      "Patentansprüche sind nicht unter den Mindesterfordernissen nach § 34 Abs. 3 Nr. 1, 2 und 4 PatG aufgeführt. Die Anmeldung erhält daher einen Anmeldetag, auch wenn Patentansprüche fehlen. Der formelle Mangel wird in der Formalprüfung beanstandet, und der Anmelder erhält Gelegenheit zur Nachreichung.",
  },

  {
    id: "da-patg2-015",
    topic: "§ 34 PatG — Anmeldeverfahren",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg34"],
    title: "Übersetzungsfrist bei Inanspruchnahme früherer Zeitpunkt",
    prompt:
      "Eine Anmeldung wird in französischer Sprache eingereicht und der Anmelder nimmt eine innere Priorität in Anspruch. Wie lange ist die Frist für die deutsche Übersetzung?",
    options: [
      { text: "15 Monate nach dem in Anspruch genommenen früheren Zeitpunkt", correct: true },
      { text: "12 Monate nach dem Anmeldetag der Nachanmeldung", correct: false },
      { text: "12 Monate nach dem in Anspruch genommenen früheren Zeitpunkt", correct: false },
      { text: "3 Monate nach dem Anmeldetag der Nachanmeldung", correct: false },
    ],
    explanation:
      "Bei Inanspruchnahme eines früheren Zeitpunkts (z.B. Priorität) anstelle des Anmeldetags beträgt die Frist für das Nachreichen der deutschen Übersetzung 15 Monate nach diesem früheren Zeitpunkt — unabhängig davon, ob die Anmeldung in englischer, französischer oder einer anderen Fremdsprache eingereicht wurde.",
  },

  // ── §§ 35–36 PatG: Anmeldetag, Zusammenfassung ──────────────────────────────

  {
    id: "da-patg2-016",
    topic: "§ 35 PatG — Anmeldetag",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg35"],
    title: "Bedeutung des Anmeldetags",
    prompt:
      "Welche zentrale Bedeutung hat der Anmeldetag einer Patentanmeldung?",
    options: [
      { text: "Er bestimmt den Zeitrang der Anmeldung, d.h. den maßgeblichen Stichtag für die Beurteilung der Neuheit und erfinderischen Tätigkeit", correct: true },
      { text: "Er löst die 20-jährige Schutzdauer des Patents aus", correct: false },
      { text: "Er bestimmt den Zeitpunkt der Offenlegung der Anmeldung", correct: false },
      { text: "Er ist maßgeblich für die Berechnung der Prüfungsantragsfrist von 3 Jahren", correct: false },
    ],
    explanation:
      "Der Anmeldetag bestimmt den Zeitrang der Anmeldung: Alles, was vor dem Anmeldetag veröffentlicht wurde, gehört zum Stand der Technik. Er ist zugleich Ausgangspunkt für die Berechnung der 20-jährigen Schutzdauer (§ 16 PatG) und der 18-monatigen Offenlegungsfrist (§ 31 PatG). Die Prüfungsantragsfrist beträgt 7 Jahre.",
  },

  {
    id: "da-patg2-017",
    topic: "§ 36 PatG — Zusammenfassung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg36"],
    title: "Funktion der Zusammenfassung",
    prompt:
      "Welche Funktion hat die Zusammenfassung gemäß § 36 PatG?",
    options: [
      { text: "Sie dient ausschließlich der technischen Unterrichtung der Öffentlichkeit und hat keinen Einfluss auf den Schutzbereich", correct: true },
      { text: "Sie definiert zusammen mit den Patentansprüchen den Schutzumfang des Patents", correct: false },
      { text: "Sie ermöglicht die Auslegung mehrdeutiger Patentansprüche bei der Sachprüfung", correct: false },
      { text: "Sie ist Grundlage für die Recherche des DPMA nach § 43 PatG", correct: false },
    ],
    explanation:
      "Die Zusammenfassung nach § 36 PatG dient ausschließlich der technischen Unterrichtung der Öffentlichkeit. Sie darf nicht zur Auslegung des Schutzbereichs und nicht zur Bestimmung des Standes der Technik herangezogen werden. Bei der Sachprüfung wird sie formell geprüft und die charakteristischste Zeichnung bestimmt.",
  },

  // ── §§ 37–38 PatG: Erfinderbenennung, Teilanmeldung, Änderungen ─────────────

  {
    id: "da-patg2-018",
    topic: "§ 37 PatG — Erfinderbenennung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg37"],
    title: "Rechtsfolge fehlender Erfinderbenennung",
    prompt:
      "Was sind die Konsequenzen, wenn die Erfinderbenennung nach § 37 PatG nicht fristgerecht eingereicht wird?",
    options: [
      { text: "Die Anmeldung gilt als formell mangelhaft; bei Nichtbeseitigung kann sie zurückgewiesen werden", correct: true },
      { text: "Die Anmeldung wird automatisch zurückgenommen", correct: false },
      { text: "Der Anmelder wird als Erfinder eingetragen", correct: false },
      { text: "Das Verfahren wird ausgesetzt bis die Erfinderbenennung nachgereicht wird", correct: false },
    ],
    explanation:
      "Das Fehlen der Erfinderbenennung innerhalb von 15 Monaten nach dem Anmeldetag stellt einen formellen Mangel gemäß § 42 PatG dar. Das DPMA fordert den Anmelder auf, den Mangel zu beseitigen. Wird dem nicht nachgekommen, kann die Anmeldung zurückgewiesen werden. Eine automatische Rücknahmefiktion tritt nicht ein.",
  },

  {
    id: "da-patg2-019",
    topic: "§ 38 PatG — Änderung der Anmeldungsunterlagen",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg38"],
    title: "Zulässigkeit von Änderungen nach § 38 PatG",
    prompt:
      "Bis zu welchem Zeitpunkt sind Änderungen der ursprünglichen Anmeldungsunterlagen nach § 38 PatG zulässig?",
    options: [
      { text: "Bis zum Beschluss über die Erteilung des Patents, sofern sie den Gegenstand der Anmeldung nicht erweitern", correct: true },
      { text: "Nur bis zur Offenlegung der Anmeldung nach § 31 PatG", correct: false },
      { text: "Bis zum Abschluss der Recherchearbeit des DPMA", correct: false },
      { text: "Nur innerhalb von 12 Monaten nach dem Anmeldetag", correct: false },
    ],
    explanation:
      "§ 38 PatG erlaubt Änderungen der ursprünglichen Anmeldungsunterlagen bis zum Beschluss über die Erteilung des Patents. Die entscheidende Grenze: Die Änderungen dürfen den Gegenstand der Anmeldung nicht erweitern. Nach der Erteilung sind Änderungen nur noch im Beschränkungs- oder Widerrufsverfahren möglich.",
  },

  {
    id: "da-patg2-020",
    topic: "§ 38 PatG — Unzulässige Erweiterung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 3,
    sources: ["patg38"],
    title: "Maßstab für unzulässige Erweiterung",
    prompt:
      "Wann liegt eine unzulässige Erweiterung im Sinne des § 38 PatG vor?",
    options: [
      { text: "Wenn der Gegenstand der geänderten Anmeldung für den Fachmann erst durch eigene, von seinem Fachwissen getragene Überlegungen erkennbar wird, nachdem er die ursprünglichen Unterlagen zur Kenntnis genommen hat", correct: true },
      { text: "Wenn die geänderten Ansprüche breiter sind als die ursprünglichen Ansprüche", correct: false },
      { text: "Wenn neue technische Merkmale in die Beschreibung eingefügt werden, die nicht in den Ansprüchen stehen", correct: false },
      { text: "Wenn die Zusammenfassung nach der Offenlegung geändert wird", correct: false },
    ],
    explanation:
      "Eine unzulässige Erweiterung nach § 38 PatG liegt vor, wenn der geänderte Gegenstand für den Fachmann erst durch eigene Überlegungen auf Basis seines Fachwissens erkennbar wird — also nicht unmittelbar und eindeutig aus den ursprünglichen Unterlagen hervorgeht. Der Inhalt der ursprünglichen Anmeldung bestimmt sich nach dem, was der Durchschnittsfachmann den ursprünglichen Unterlagen als zur Erfindung gehörig entnehmen kann.",
  },

  {
    id: "da-patg2-021",
    topic: "§ 38 PatG — Teilanmeldung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg38"],
    title: "Ausscheidungserklärung bei Uneinheitlichkeit",
    prompt:
      "Was versteht man unter einer Ausscheidungserklärung im Zusammenhang mit der Uneinheitlichkeitsprüfung?",
    options: [
      { text: "Die Mitteilung des Anmelders, welcher Gegenstand in der Stammanmeldung verbleiben soll", correct: true },
      { text: "Die Erklärung des DPMA, welche Ansprüche aus der Anmeldung ausgeschieden werden", correct: false },
      { text: "Den Antrag auf Teilanmeldung für den ausgeschiedenen Gegenstand", correct: false },
      { text: "Die Rücknahme der Ansprüche, die keiner einzigen erfinderischen Idee zuzuordnen sind", correct: false },
    ],
    explanation:
      "Bei festgestellter Uneinheitlichkeit einer Anmeldung erfolgt die sachliche Prüfung zunächst nur für einen der als uneinheitlich festgestellten Gegenstände. Die Ausscheidungserklärung ist die Mitteilung des Anmelders, welcher Gegenstand in der Stammanmeldung verbleiben soll. Der ausgeschiedene Gegenstand kann in einer Teilanmeldung weiterverfolgt werden.",
  },

  // ── §§ 42–44 PatG: Formalprüfung, Recherche, Sachprüfung ───────────────────

  {
    id: "da-patg2-022",
    topic: "§ 42 PatG — Formalprüfung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg42"],
    title: "Gegenstand der Formalprüfung",
    prompt:
      "Was ist Gegenstand der Formalprüfung (Offensichtlichkeitsprüfung) gemäß § 42 PatG?",
    options: [
      { text: "Die Anforderungen der §§ 34, 36, 37 und 38 PatG auf offensichtliche Mängel", correct: true },
      { text: "Die Patentfähigkeit der Erfindung nach §§ 1 bis 5 PatG", correct: false },
      { text: "Die formellen Anforderungen und die vollständige Patentfähigkeitsprüfung", correct: false },
      { text: "Ausschließlich die Vollständigkeit der eingereichten Unterlagen", correct: false },
    ],
    explanation:
      "Die Formalprüfung nach § 42 PatG ist eine Offensichtlichkeitsprüfung der Anforderungen der §§ 34, 36, 37 und 38 PatG. Sie prüft also formelle Anforderungen an die Anmeldung. Die Patentfähigkeit (§§ 1–5 PatG) ist Gegenstand der Sachprüfung nach § 44 PatG und wird in der Formalprüfung nur bei offensichtlichem Fehlen der gewerblichen Anwendbarkeit berücksichtigt.",
  },

  {
    id: "da-patg2-023",
    topic: "§ 42 PatG — Formalprüfung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg42"],
    title: "Prüfung der gewerblichen Anwendbarkeit in Formalprüfung",
    prompt:
      "Unter welcher Voraussetzung kann das DPMA das Fehlen der gewerblichen Anwendbarkeit bereits in der Formalprüfung (§ 42 PatG) beanstanden?",
    options: [
      { text: "Nur wenn das Fehlen der gewerblichen Anwendbarkeit ohne Zweifel und ohne weitere Nachforschungen aus den Anmeldungsunterlagen hervorgeht", correct: true },
      { text: "Immer dann, wenn der Prüfer Zweifel an der gewerblichen Anwendbarkeit hat", correct: false },
      { text: "Nur nach einer abgeschlossenen Recherche nach § 43 PatG", correct: false },
      { text: "Nur wenn der Anmelder keinen Prüfungsantrag gestellt hat", correct: false },
    ],
    explanation:
      "In der Formalprüfung wird das Fehlen der gewerblichen Anwendbarkeit (§ 5 PatG) nur dann beanstandet, wenn es sich offensichtlich — d.h. ohne Zweifel und ohne weitere Nachforschungen — aus den Anmeldungsunterlagen ergibt. Eine detaillierte Patentfähigkeitsprüfung findet erst nach Prüfungsantrag im Rahmen der Sachprüfung statt.",
  },

  {
    id: "da-patg2-024",
    topic: "§ 42 PatG — Formelle Mängel",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "multi",
    level: 2,
    sources: ["patg42"],
    title: "Typische formelle Mängel",
    prompt:
      "Welche der folgenden Sachverhalte stellen typische formelle Mängel dar, die in der Formalprüfung nach § 42 PatG beanstandet werden?",
    options: [
      { text: "Die Bezeichnung der Erfindung ist nicht kurz und genau (§ 34 Abs. 3 Nr. 2 PatG)", correct: true },
      { text: "Die Anmeldegebühr wurde nicht vollständig oder nicht rechtzeitig gezahlt", correct: true },
      { text: "Die Erfindung hat keine erfinderische Tätigkeit gegenüber dem Stand der Technik", correct: false },
      { text: "Bei mehreren Anmeldern ohne gemeinsamen Vertreter wurde kein Zustellungsbevollmächtigter benannt", correct: true },
    ],
    explanation:
      "Typische formelle Mängel nach § 42 PatG umfassen u.a.: ungenaue Erfindungsbezeichnung (§ 34 Abs. 3 Nr. 2 PatG), fehlende oder nicht rechtzeitige Anmeldegebühr, fehlender Zustellungsbevollmächtigter bei mehreren Anmeldern ohne gemeinsamen Vertreter, fehlende Erfinderbenennung. Die mangelnde erfinderische Tätigkeit ist dagegen kein formeller, sondern ein materieller Mangel und wird erst in der Sachprüfung geprüft.",
  },

  {
    id: "da-patg2-025",
    topic: "§ 43 PatG — Recherche",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg42"],
    title: "Rechercheantragsgebühr",
    prompt:
      "Wie hoch ist die Recherchegebühr nach § 43 PatG beim DPMA?",
    options: [
      { text: "300 Euro", correct: true },
      { text: "150 Euro", correct: false },
      { text: "350 Euro", correct: false },
      { text: "500 Euro", correct: false },
    ],
    explanation:
      "Die Recherchegebühr nach § 43 PatG beträgt 300 Euro. Sie ist von der Prüfungsgebühr zu unterscheiden: Die Prüfungsgebühr beträgt 350 Euro ohne vorherigen Rechercheantrag, aber nur 150 Euro wenn zuvor ein Rechercheantrag gestellt wurde. Durch die Kombination Recherche + Prüfung spart man 200 Euro gegenüber dem direkten Prüfungsantrag.",
  },

  {
    id: "da-patg2-026",
    topic: "§ 44 PatG — Prüfungsantrag",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg44"],
    title: "Frist für den Prüfungsantrag",
    prompt:
      "Bis wann kann ein Prüfungsantrag nach § 44 PatG beim DPMA gestellt werden?",
    options: [
      { text: "Bis 7 Jahre nach Einreichung der Anmeldung", correct: true },
      { text: "Bis 3 Jahre nach Einreichung der Anmeldung", correct: false },
      { text: "Bis 5 Jahre nach Einreichung der Anmeldung", correct: false },
      { text: "Innerhalb von 18 Monaten nach Einreichung der Anmeldung", correct: false },
    ],
    explanation:
      "Der Prüfungsantrag nach § 44 PatG kann bis zu 7 Jahre nach Einreichung der Anmeldung gestellt werden. Wird kein Prüfungsantrag innerhalb dieser Frist gestellt, gilt die Anmeldung als zurückgenommen. Diese lange Frist gibt dem Anmelder Zeit, die wirtschaftliche Bedeutung der Erfindung zu bewerten, bevor er die nicht unerheblichen Prüfungskosten trägt.",
  },

  {
    id: "da-patg2-027",
    topic: "§ 44 PatG — Sachprüfung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg44"],
    title: "Gegenstand der Sachprüfung",
    prompt:
      "Was prüft das DPMA im Rahmen der Sachprüfung nach § 44 PatG?",
    options: [
      { text: "Die Anforderungen der §§ 34, 37 und 38 PatG sowie die Patentfähigkeit nach §§ 1 bis 5 PatG", correct: true },
      { text: "Ausschließlich die Patentfähigkeit nach §§ 1 bis 5 PatG", correct: false },
      { text: "Die Anforderungen der §§ 34, 36, 37 und 38 PatG sowie die Patentfähigkeit", correct: false },
      { text: "Nur die Neuheit und erfinderische Tätigkeit der Erfindung", correct: false },
    ],
    explanation:
      "Die Sachprüfung nach § 44 PatG umfasst die Anforderungen der §§ 34, 37 und 38 PatG (nicht § 36!) sowie die Patentfähigkeit nach §§ 1 bis 5 PatG. Beachte: § 36 PatG (Zusammenfassung) wird in der Formalprüfung (§ 42 PatG), nicht aber explizit in § 44 PatG genannt — er wird aber gleichwohl in der Sachprüfung im Rahmen der Vollständigkeitsprüfung berücksichtigt.",
  },

  {
    id: "da-patg2-028",
    topic: "§ 44 PatG — Sachprüfung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg44"],
    title: "Prüfungsgebühr nach vorangegangenem Rechercheantrag",
    prompt:
      "Ein Anmelder hat bereits einen Rechercheantrag nach § 43 PatG gestellt. Wie hoch ist die Prüfungsgebühr, wenn er nun auch einen Prüfungsantrag nach § 44 PatG stellt?",
    options: [
      { text: "150 Euro", correct: true },
      { text: "350 Euro", correct: false },
      { text: "300 Euro", correct: false },
      { text: "200 Euro", correct: false },
    ],
    explanation:
      "Wenn bereits ein Rechercheantrag nach § 43 PatG gestellt wurde, reduziert sich die Prüfungsgebühr auf 150 Euro (statt 350 Euro ohne vorherigen Rechercheantrag). Der Gesamtaufwand für Recherche + Prüfung beträgt damit 450 Euro — 50 Euro weniger als der direkte Prüfungsantrag ohne Recherche (350 Euro), dafür aber mit dem Mehrwert des Rechercheberichts.",
  },

  // ── Jahresgebühren und Kostenregelungen ─────────────────────────────────────

  {
    id: "da-patg2-029",
    topic: "§ 17 PatG — Jahresgebühren",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg"],
    title: "Beginn der Jahresgebührenpflicht",
    prompt:
      "Ab welchem Jahr muss für eine Patentanmeldung oder ein Patent eine Jahresgebühr entrichtet werden?",
    options: [
      { text: "Ab dem dritten Jahr, gerechnet vom Anmeldetag an", correct: true },
      { text: "Ab dem ersten Jahr nach Erteilung des Patents", correct: false },
      { text: "Ab dem fünften Jahr, gerechnet vom Anmeldetag an", correct: false },
      { text: "Ab dem zweiten Jahr, gerechnet vom Anmeldetag an", correct: false },
    ],
    explanation:
      "Nach § 17 PatG ist für jede Anmeldung und jedes Patent für das dritte und jedes folgende Jahr, gerechnet vom Anmeldetag an, eine Jahresgebühr zu entrichten. Die ersten zwei Schutzjahre sind durch die Anmeldegebühr abgedeckt. Ab Beginn des 3. Schutzjahres müssen die Jahresgebühren unaufgefordert gezahlt werden.",
  },

  {
    id: "da-patg2-030",
    topic: "§ 17 PatG — Jahresgebühren Fälligkeit",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Fälligkeit der Jahresgebühr",
    prompt:
      "Eine Patentanmeldung wird am 29. November 2023 eingereicht. Wann wird die 3. Jahresgebühr fällig?",
    options: [
      { text: "Am 30. November 2025", correct: true },
      { text: "Am 29. November 2025", correct: false },
      { text: "Am 29. November 2026", correct: false },
      { text: "Am 30. November 2026", correct: false },
    ],
    explanation:
      "Die Jahresgebühr ist am letzten Tag des Monats zwei Jahre nach der Anmeldung fällig, in dem die jeweilige Schutzdauer endet. Bei einer Anmeldung am 29.11.2023 endet das 3. Schutzjahr am 29.11.2025, die Jahresgebühr wird also am letzten Tag dieses Monats, dem 30.11.2025, fällig.",
  },

  {
    id: "da-patg2-031",
    topic: "§ 7 PatKostG — Jahresgebühren Verspätung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Nachzahlungsfrist und Verspätungszuschlag",
    prompt:
      "Ein Patentinhaber vergisst die Zahlung der Jahresgebühr am Fälligkeitstag. Welche Möglichkeiten hat er noch?",
    options: [
      { text: "Er kann die Gebühr bis 2 Monate nach Fälligkeit noch ohne Zuschlag zahlen; danach noch bis 6 Monate nach Fälligkeit mit einem Verspätungszuschlag von 50 Euro", correct: true },
      { text: "Er kann die Gebühr nur noch bis 3 Monate nach Fälligkeit mit einem Zuschlag von 100 Euro zahlen", correct: false },
      { text: "Das Patent erlischt automatisch am Fälligkeitstag, eine Nachzahlung ist nicht mehr möglich", correct: false },
      { text: "Er kann die Gebühr bis 6 Monate nach Fälligkeit ohne Zuschlag zahlen", correct: false },
    ],
    explanation:
      "Nach § 7 PatKostG können Jahresgebühren bis zum Ablauf des zweiten Monats nach Fälligkeit noch fristgerecht gezahlt werden. Wird die Gebühr innerhalb dieser 2-Monatsfrist nicht gezahlt, kann sie mit einem Verspätungszuschlag von 50 Euro noch bis zum Ablauf des sechsten Monats nach Fälligkeit gezahlt werden. Danach erlischt das Patent.",
  },

  {
    id: "da-patg2-032",
    topic: "§ 17 PatG — Jahresgebühren Bündelung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Gebührenbündelung 3.–5. Schutzjahr",
    prompt:
      "Welche Gebührenersparnis ergibt sich, wenn die 3. bis 5. Jahresgebühr zusammen bei Fälligkeit der 3. Jahresgebühr gezahlt werden?",
    options: [
      { text: "30 Euro Ersparnis (210 Euro statt 240 Euro bei Einzelzahlung)", correct: false },
      { text: "60 Euro Ersparnis (180 Euro statt 240 Euro)", correct: false },
      { text: "Keine Ersparnis, nur Vereinfachung der Verwaltung", correct: true },
      { text: "50 Euro Ersparnis (190 Euro statt 240 Euro)", correct: false },
    ],
    explanation:
      "Das PatKostG kennt keinen Bündelungsrabatt. Werden mehrere Jahresgebühren gemeinsam gezahlt, wird schlicht die Summe der Einzelgebühren fällig — ohne jede Ermäßigung. Eine 'Ersparnis' durch Zusammenfassung der 3.–5. Jahresgebühr entsteht nicht; die gemeinsame Zahlung dient allein der verwaltungstechnischen Vereinfachung. Richtig ist daher: keine Ersparnis (Option C).",
  },

  {
    id: "da-patg2-033",
    topic: "§ 23 PatG — Lizenzbereitschaft",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Wirkung der Lizenzbereitschaftserklärung",
    prompt:
      "Welche finanzielle Vergünstigung ergibt sich aus einer Lizenzbereitschaftserklärung nach § 23 PatG?",
    options: [
      { text: "Die nach Eingang der Erklärung fällig werdenden Jahresgebühren ermäßigen sich auf die Hälfte", correct: true },
      { text: "Die Anmeldegebühr wird rückwirkend erstattet", correct: false },
      { text: "Alle zukünftigen Jahresgebühren entfallen vollständig", correct: false },
      { text: "Die Prüfungsgebühr wird auf die Hälfte reduziert", correct: false },
    ],
    explanation:
      "Nach § 23 Abs. 1 PatG ermäßigen sich die nach Eingang der Lizenzbereitschaftserklärung fällig werdenden Jahresgebühren auf die Hälfte. Voraussetzung ist eine schriftliche Erklärung gegenüber dem DPMA, jedermann die Benutzung gegen angemessene Vergütung zu gestatten. Die Erklärung wird im Register eingetragen und im Patentblatt veröffentlicht.",
  },

  // ── Vertretung und Anwaltszwang ─────────────────────────────────────────────

  {
    id: "da-patg2-034",
    topic: "§ 25 PatG — Anwaltszwang",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg"],
    title: "Anwaltszwang vor dem DPMA",
    prompt:
      "Gilt vor dem DPMA ein Anwaltszwang für Patentanmeldungen?",
    options: [
      { text: "Grundsätzlich nicht für Anmelder mit Wohnsitz, Sitz oder Niederlassung in Deutschland; Ausländer müssen einen Rechtsanwalt oder Patentanwalt bestellen", correct: true },
      { text: "Ja, für alle Anmelder ohne Ausnahme", correct: false },
      { text: "Nein, vor dem DPMA gilt generell kein Anwaltszwang", correct: false },
      { text: "Nur für juristische Personen; natürliche Personen können sich stets selbst vertreten", correct: false },
    ],
    explanation:
      "§ 25 Abs. 1 PatG sieht keinen Anwaltszwang für Anmelder mit Wohnsitz, Sitz oder Niederlassung in Deutschland vor. Anmelder ohne Wohnsitz, Sitz oder Niederlassung in Deutschland müssen dagegen — unabhängig von ihrer Staatsangehörigkeit — einen in Deutschland zugelassenen Rechtsanwalt oder Patentanwalt als Inlandsvertreter bestellen.",
  },

  {
    id: "da-patg2-035",
    topic: "§ 25 PatG — Verletzungsverfahren",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Anwaltszwang im Verletzungsverfahren",
    prompt:
      "Gilt im Patentverletzungsverfahren vor dem Landgericht ein Anwaltszwang?",
    options: [
      { text: "Ja, es gilt Rechtsanwaltszwang gemäß § 78 ZPO i.V.m. § 143 PatG", correct: true },
      { text: "Nein, auch im Verletzungsverfahren können sich Parteien selbst vertreten", correct: false },
      { text: "Nur für ausländische Parteien; Inländer können sich selbst vertreten", correct: false },
      { text: "Es gilt Patentanwaltszwang, nicht Rechtsanwaltszwang", correct: false },
    ],
    explanation:
      "Im Patentverletzungsverfahren vor dem Landgericht gilt Rechtsanwaltszwang nach § 78 ZPO i.V.m. § 143 PatG. Dies ist eine wichtige Ausnahme vom fehlenden Anwaltszwang im Verwaltungsverfahren vor dem DPMA. Der Patentanwalt kann im Verletzungsverfahren als technischer Berater hinzugezogen werden, muss aber von einem Rechtsanwalt vertreten werden.",
  },

  {
    id: "da-patg2-036",
    topic: "§ 25 PatG — Inlandsvertreter",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Grenzen der Vollmacht des Inlandsvertreters",
    prompt:
      "Was kann ein Inlandsvertreter aufgrund seiner Vollmacht nicht tun?",
    options: [
      { text: "Materiell-rechtliche Verfügungen vornehmen, wie die Erklärung der Lizenzbereitschaft oder den Verzicht auf das Patent", correct: true },
      { text: "Patentansprüche ändern", correct: false },
      { text: "Die Anmeldung teilen", correct: false },
      { text: "Die Anmeldung zurücknehmen", correct: false },
    ],
    explanation:
      "Die Vollmacht des Inlandsvertreters umfasst Verfahrenshandlungen wie Ansprüche ändern, Anmeldung teilen und Anmeldung zurücknehmen. Nicht umfasst sind materiell-rechtliche Verfügungen wie die Erklärung der Lizenzbereitschaft (§ 23 PatG) oder der Verzicht auf das Patent — hierfür bedarf es einer ausdrücklichen besonderen Ermächtigung.",
  },

  // ── Prioritäten: Innere Priorität (§ 40 PatG) ──────────────────────────────

  {
    id: "da-patg2-037",
    topic: "§ 40 PatG — Innere Priorität",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg"],
    title: "Prioritätsfrist bei innerer Priorität",
    prompt:
      "Innerhalb welcher Frist muss eine Nachanmeldung eingereicht werden, um die innere Priorität gemäß § 40 PatG wirksam in Anspruch nehmen zu können?",
    options: [
      { text: "Vor Ablauf von 12 Monaten nach dem Anmeldetag der früheren Anmeldung", correct: true },
      { text: "Vor Ablauf von 16 Monaten nach dem Anmeldetag der früheren Anmeldung", correct: false },
      { text: "Vor Ablauf von 6 Monaten nach dem Anmeldetag der früheren Anmeldung", correct: false },
      { text: "Vor Ablauf von 18 Monaten nach dem Anmeldetag der früheren Anmeldung", correct: false },
    ],
    explanation:
      "Die Prioritätsfrist für die innere Priorität nach § 40 Abs. 1 PatG beträgt 12 Monate nach dem Anmeldetag der früheren Anmeldung. Im Unterschied zur äußeren Priorität (§ 41 PatG) ist bei der inneren Priorität nach Ablauf der Frist keine Wiedereinsetzung möglich (§ 123 Abs. 1 S. 2 Nr. 3 PatG).",
  },

  {
    id: "da-patg2-038",
    topic: "§ 40 PatG — Innere Priorität",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Rücknahmefiktion bei innerer Priorität",
    prompt:
      "Was bewirkt die wirksame Inanspruchnahme einer inneren Priorität nach § 40 PatG bezüglich der früheren Anmeldung?",
    options: [
      { text: "Die frühere Anmeldung gilt als zurückgenommen (Rücknahmefiktion) mit Eingang der wirksamen Prioritätserklärung", correct: true },
      { text: "Die frühere Anmeldung wird automatisch in die Nachanmeldung übergeführt", correct: false },
      { text: "Die frühere Anmeldung bleibt vollständig bestehen und kann parallel weiterverfolgt werden", correct: false },
      { text: "Die frühere Anmeldung wird zurückgewiesen", correct: false },
    ],
    explanation:
      "§ 40 Abs. 5 PatG begründet eine Rücknahmefiktion: Die frühere deutsche Anmeldung gilt als zurückgenommen, sobald die wirksame Prioritätserklärung beim DPMA eingeht. Dies verhindert eine doppelte Prüfung zeitrang- und gegenstandsgleicher Anmeldungen. Die eingetretene Fiktion kann nicht nachträglich durch Verzicht auf die Prioritätserklärung aufgehoben werden.",
  },

  {
    id: "da-patg2-039",
    topic: "§ 40 PatG — Innere Priorität",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 3,
    sources: ["patg"],
    title: "Rücknahmefiktion — Ausnahmen",
    prompt:
      "In welchem Fall tritt die Rücknahmefiktion nach § 40 Abs. 5 PatG NICHT ein?",
    options: [
      { text: "Wenn die Nachanmeldung eine Gebrauchsmusteranmeldung ist und die Priorität einer früheren deutschen Patentanmeldung in Anspruch genommen wird", correct: true },
      { text: "Wenn nur ein Teil der Erstanmeldung für die Nachanmeldung in Anspruch genommen wurde", correct: false },
      { text: "Wenn die frühere Anmeldung eine PCT-Anmeldung mit DPMA als Bestimmungsamt war", correct: false },
      { text: "Wenn die frühere Anmeldung in eine nationale Anmeldung umgewandelte europäische Anmeldung ist", correct: false },
    ],
    explanation:
      "Die Rücknahmefiktion tritt nicht ein, wenn die Nachanmeldung eine Gebrauchsmusteranmeldung gemäß § 6(1) S.2 GmbG ist und die Priorität einer früheren deutschen Patentanmeldung in Anspruch genommen wird (§ 40 Abs. 5 S. 2 PatG). Sie tritt auch nicht ein für ein bereits erteiltes Patent oder wenn Vor- und Nachanmeldung nicht dieselbe Erfindung zum Gegenstand haben.",
  },

  {
    id: "da-patg2-040",
    topic: "§ 40 PatG — Identität der Erfindung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 3,
    sources: ["patg"],
    title: "Erfindungsidentität bei innerer Priorität",
    prompt:
      "Was gilt für die Erfindungsidentität zwischen Vor- und Nachanmeldung bei der inneren Priorität?",
    options: [
      { text: "Vor- und Nachanmeldung müssen im Wesentlichen denselben Erfindungsgedanken aufweisen; die Nachanmeldung kann zusätzliche Merkmale enthalten", correct: true },
      { text: "Vor- und Nachanmeldung müssen wortgleich sein", correct: false },
      { text: "Die Nachanmeldung darf keine zusätzlichen Merkmale gegenüber der Voranmeldung enthalten", correct: false },
      { text: "Völlig unterschiedliche Erfindungen können unter Inanspruchnahme innerer Priorität angemeldet werden", correct: false },
    ],
    explanation:
      "Für die innere Priorität müssen Vor- und Nachanmeldung im Wesentlichen denselben Erfindungsgedanken aufweisen. Die Nachanmeldung darf jedoch zusätzliche Merkmale enthalten, die in der früheren Anmeldung nicht enthalten waren — Aufgabe und Lösung dürfen in der späteren Anmeldung weiterentwickelt werden. Das Prioritätsrecht besteht aber nur für die Merkmale, die in der früheren Anmeldung ausreichend deutlich offenbart sind (§ 40 Abs. 3 PatG).",
  },

  {
    id: "da-patg2-041",
    topic: "§ 40 PatG — Mehrfachpriorität",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Mehrfachpriorität",
    prompt:
      "Was gilt hinsichtlich der Mehrfachpriorität gemäß § 40 Abs. 2 PatG?",
    options: [
      { text: "Eine Nachanmeldung kann die Priorität von mehreren Voranmeldungen in Anspruch nehmen; umgekehrt können mehrere Nachanmeldungen dieselbe Priorität einer früheren Anmeldung beanspruchen", correct: true },
      { text: "Eine Nachanmeldung kann nur die Priorität einer einzigen früheren Anmeldung in Anspruch nehmen", correct: false },
      { text: "Jede Voranmeldung kann nur einmal als Prioritätsbasis dienen", correct: false },
      { text: "Mehrfachpriorität ist nur bei ausländischen Anmeldungen möglich", correct: false },
    ],
    explanation:
      "§ 40 Abs. 2 PatG erlaubt Mehrfachpriorität in beide Richtungen: Eine Nachanmeldung kann die Priorität von mehreren Voranmeldungen in Anspruch nehmen (z.B. für verschiedene Ansprüche). Umgekehrt können mehrere Nachanmeldungen dieselbe Priorität einer früheren Anmeldung beanspruchen — sofern die sachlichen Voraussetzungen erfüllt sind.",
  },

  {
    id: "da-patg2-042",
    topic: "§ 40 PatG — Kettenpriorität",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 3,
    sources: ["patg"],
    title: "Kettenpriorität",
    prompt:
      "Was gilt für die Kettenpriorität — also die Inanspruchnahme der Priorität einer Nachanmeldung, die selbst bereits eine Priorität in Anspruch nimmt?",
    options: [
      { text: "Grundsätzlich unzulässig; ausnahmsweise zulässig für Merkmale, die erst in der Nachanmeldung offenbart wurden und nicht in der Erstanmeldung enthalten waren", correct: true },
      { text: "Stets zulässig, da jede Anmeldung als Prioritätsbasis dienen kann", correct: false },
      { text: "Stets unzulässig ohne jede Ausnahme", correct: false },
      { text: "Zulässig, wenn zwischen den Anmeldungen mehr als 6 Monate liegen", correct: false },
    ],
    explanation:
      "Die Kettenpriorität — die Inanspruchnahme der Priorität einer Nachanmeldung, die bereits eine erste Priorität in Anspruch nimmt — ist nach § 40 Abs. 1 PatG grundsätzlich unzulässig. Ausnahmsweise ist sie jedoch möglich für Merkmale, die nicht in der Erstanmeldung enthalten waren und erst in der Nachanmeldung offenbart wurden. Diese Merkmale haben dann keinen Prioritätsschutz aus der Erstanmeldung.",
  },

  // ── Äußere Priorität (§ 41 PatG) ───────────────────────────────────────────

  {
    id: "da-patg2-043",
    topic: "§ 41 PatG — Äußere Priorität",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Frist für Prioritätserklärung bei äußerer Priorität",
    prompt:
      "Innerhalb welcher Frist muss die Prioritätserklärung für eine äußere Priorität abgegeben werden, und welche Angaben sind erforderlich?",
    options: [
      { text: "Vor Ablauf von 16 Monaten nach dem Anmeldetag der früheren Anmeldung, unter Angabe von Zeit, Land und Aktenzeichen sowie Einreichung einer Abschrift der früheren Anmeldung", correct: true },
      { text: "Vor Ablauf von 12 Monaten nach dem Anmeldetag der früheren Anmeldung, unter Angabe von Zeit, Land und Aktenzeichen", correct: false },
      { text: "Innerhalb von 2 Monaten nach dem Anmeldetag der Nachanmeldung, unter Angabe des Aktenzeichens der früheren Anmeldung", correct: false },
      { text: "Vor Ablauf von 18 Monaten nach dem Anmeldetag der früheren Anmeldung, ohne besondere Formvorschriften", correct: false },
    ],
    explanation:
      "Die Prioritätserklärung für die äußere Priorität (§ 41 PatG) muss vor Ablauf von 16 Monaten nach dem Anmeldetag der früheren Anmeldung abgegeben werden. Sie muss Zeit, Land und Aktenzeichen der früheren Anmeldung enthalten sowie eine Abschrift der früheren Anmeldung. Im Unterschied zur inneren Priorität (12 Monate) ist bei der äußeren Priorität eine Wiedereinsetzung nach Fristablauf möglich.",
  },

  {
    id: "da-patg2-044",
    topic: "§ 41 PatG — Äußere Priorität vs. innere Priorität",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Wiedereinsetzung bei versäumter Prioritätsfrist",
    prompt:
      "Bei welcher Prioritätsart ist eine Wiedereinsetzung nach Ablauf der Prioritätsfrist möglich?",
    options: [
      { text: "Nur bei der äußeren Priorität gemäß § 123 Abs. 7 PatG, nicht bei der inneren Priorität", correct: true },
      { text: "Bei beiden Prioritätsarten gleichermaßen", correct: false },
      { text: "Nur bei der inneren Priorität", correct: false },
      { text: "Bei keiner der beiden Prioritätsarten", correct: false },
    ],
    explanation:
      "§ 123 Abs. 1 S. 2 Nr. 3 PatG schließt die Wiedereinsetzung für die Frist zur Inanspruchnahme der inneren Priorität (§ 40 PatG) ausdrücklich aus — insoweit ist nach Ablauf der 12-Monatsfrist keine Wiedereinsetzung möglich. Für die äußere (Unions-)Priorität (§ 41 PatG) gilt dieser Ausschluss nicht; sie ist daher wiedereinsetzungsfähig. § 123 Abs. 5/7 PatG bestätigt das, indem er für genau diesen Fall (Anmeldung, die infolge Wiedereinsetzung die Priorität einer früheren ausländischen Anmeldung in Anspruch nimmt) ein gutgläubiges Weiterbenutzungsrecht regelt. Ergebnis: Wiedereinsetzung nur bei der äußeren Priorität, nicht bei der inneren.",
  },

  {
    id: "da-patg2-045",
    topic: "§ 40 PatG — Wirksame Prioritätserklärung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Formerfordernisse der inneren Prioritätserklärung",
    prompt:
      "Was muss eine wirksame Prioritätserklärung für die innere Priorität nach § 40 PatG enthalten?",
    options: [
      { text: "Die Erklärung muss erkennen lassen, dass der Anmeldetag einer früheren DPMA-Anmeldung beansprucht wird, und das Aktenzeichen der früheren Anmeldung nennen", correct: true },
      { text: "Die vollständige Abschrift der früheren Anmeldung sowie Aktenzeichen und Anmeldetag", correct: false },
      { text: "Nur das Aktenzeichen der früheren Anmeldung; weitere Angaben sind nicht erforderlich", correct: false },
      { text: "Die Erklärung, Zeit, Land und Aktenzeichen — wie bei der äußeren Priorität", correct: false },
    ],
    explanation:
      "Die wirksame Prioritätserklärung für die innere Priorität erfordert: (1) die Erklärung lässt erkennen, dass der Anmeldetag einer früheren beim DPMA eingereichten Anmeldung beansprucht wird, und (2) das Aktenzeichen der früheren Anmeldung ist genannt. Die Angaben müssen innerhalb von 2 Monaten nach dem Anmeldetag der Nachanmeldung gemäß § 40 Abs. 4 PatG nachgeholt werden können.",
  },

  // ── Verfahrensabläufe und Zustellung ───────────────────────────────────────

  {
    id: "da-patg2-046",
    topic: "§ 127 PatG — Zustellung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg"],
    title: "Zustellungsregeln vor DPMA und BPatG",
    prompt:
      "Welche Zustellungsvorschriften gelten vor dem DPMA und welche vor dem BPatG?",
    options: [
      { text: "DPMA: Verwaltungszustellungsgesetz (VwZG); BPatG: Zivilprozessordnung (ZPO)", correct: true },
      { text: "Vor beiden Behörden gilt das Verwaltungszustellungsgesetz (VwZG)", correct: false },
      { text: "DPMA: Zivilprozessordnung (ZPO); BPatG: Verwaltungszustellungsgesetz (VwZG)", correct: false },
      { text: "Vor beiden Behörden gilt die Zivilprozessordnung (ZPO)", correct: false },
    ],
    explanation:
      "§ 127 PatG regelt die Zustellung: Vor dem DPMA gelten die Vorschriften des Verwaltungszustellungsgesetzes (VwZG), vor dem BPatG die Vorschriften der Zivilprozessordnung (ZPO). Dieser Unterschied erklärt sich aus der unterschiedlichen Rechtsnatur der Verfahren: Das DPMA ist eine Verwaltungsbehörde, das BPatG ein Gericht.",
  },

  {
    id: "da-patg2-047",
    topic: "§ 30 PatG — Umschreibung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Rechtsfolge vor Eintragung der Umschreibung",
    prompt:
      "Was gilt gemäß § 30 Abs. 3 PatG, wenn eine Änderung in der Person des Patentinhabers noch nicht im Register eingetragen ist?",
    options: [
      { text: "Der frühere Anmelder oder Patentinhaber bleibt nach Maßgabe des Gesetzes berechtigt und verpflichtet, bis die Änderung eingetragen ist", correct: true },
      { text: "Die Änderung ist sofort wirksam, auch ohne Eintragung", correct: false },
      { text: "Die Anmeldung gilt bis zur Eintragung als zurückgenommen", correct: false },
      { text: "Zustellungen an den früheren Inhaber sind stets unwirksam", correct: false },
    ],
    explanation:
      "§ 30 Abs. 3 PatG stellt klar: Solange eine Änderung in der Person des Anmelders oder Patentinhabers nicht im Register eingetragen ist, bleibt der frühere Anmelder bzw. Patentinhaber nach Maßgabe des Gesetzes berechtigt und verpflichtet. Zustellungen an den bisherigen Inhaber sind damit bis zur Umschreibung wirksam.",
  },

  {
    id: "da-patg2-048",
    topic: "§ 42 PatG — Anmeldegebühr",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 1,
    sources: ["patg42"],
    title: "Anmeldegebühr bei elektronischer Einreichung",
    prompt:
      "Wie hoch ist die Anmeldegebühr bei elektronischer Einreichung einer Patentanmeldung mit bis zu 10 Patentansprüchen?",
    options: [
      { text: "40 Euro", correct: true },
      { text: "60 Euro", correct: false },
      { text: "100 Euro", correct: false },
      { text: "20 Euro", correct: false },
    ],
    explanation:
      "Die Anmeldegebühr bei elektronischer Einreichung beträgt 40 Euro (inklusive 10 Patentansprüchen). Bei Anmeldung in Papierform sind es 60 Euro. Für jeden weiteren Anspruch über die ersten 10 hinaus fallen bei elektronischer Einreichung 20 Euro, bei Papierform 30 Euro je zusätzlichem Anspruch an.",
  },

  {
    id: "da-patg2-049",
    topic: "§ 6 PatKostG — Gebührenfrist",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "single",
    level: 2,
    sources: ["patg"],
    title: "Rechtsfolge nicht rechtzeitiger Gebührenzahlung",
    prompt:
      "Was gilt gemäß § 6 Abs. 2 PatKostG, wenn eine gesetzlich bestimmte Gebühr nicht, nicht vollständig oder nicht rechtzeitig gezahlt wird?",
    options: [
      { text: "Die Anmeldung oder der Antrag gilt als zurückgenommen, oder die Handlung gilt als nicht vorgenommen", correct: true },
      { text: "Es wird automatisch ein Verspätungszuschlag von 50 Euro erhoben", correct: false },
      { text: "Das DPMA setzt eine Nachfrist von 3 Monaten", correct: false },
      { text: "Die Anmeldung wird zurückgewiesen, aber nicht als zurückgenommen behandelt", correct: false },
    ],
    explanation:
      "§ 6 Abs. 2 PatKostG bestimmt: Wird eine gesetzlich bestimmte Gebühr nicht, nicht vollständig oder nicht rechtzeitig gezahlt, so gilt die Anmeldung oder der Antrag als zurückgenommen, oder die Handlung als nicht vorgenommen. Dies ist eine gesetzliche Fiktion — die Folge tritt von Gesetzes wegen ein, ohne dass es einer gesonderten Entscheidung des DPMA bedarf.",
  },

  {
    id: "da-patg2-050",
    topic: "§ 40 PatG — Frühere Anmeldung",
    mode: "ausbildung",
    reviewStatus: "beta-ready",
    kind: "multi",
    level: 3,
    sources: ["patg"],
    title: "Keine frühere Anmeldung im Sinne des § 40 PatG",
    prompt:
      "Welche der folgenden Anmeldungen können NICHT als frühere Anmeldung im Sinne des § 40 PatG für die innere Priorität dienen?",
    options: [
      { text: "Geschmacksmusteranmeldungen", correct: true },
      { text: "Anmeldungen ohne anerkannten Anmeldetag", correct: true },
      { text: "Gebrauchsmusteranmeldungen beim DPMA", correct: false },
      { text: "Eine Anmeldung, die bereits Grundlage einer früheren Prioritätsinanspruchnahme war (wenn nicht Erstanmeldung)", correct: true },
    ],
    explanation:
      "Als frühere Anmeldung im Sinne des § 40 PatG gelten nur Patent- oder Gebrauchsmusteranmeldungen, die ordnungsgemäß beim DPMA eingereicht wurden und deren Anmeldetag vor dem Anmeldetag der späteren Anmeldung liegt. Nicht geeignet sind: Geschmacksmusteranmeldungen, Anmeldungen ohne anerkannten Anmeldetag, und Anmeldungen die bereits eine Priorität in Anspruch nahmen (keine Erstanmeldung). Gebrauchsmusteranmeldungen beim DPMA hingegen sind geeignete Prioritätsgrundlagen.",
  },
];
